import React, { useState, useEffect, useRef } from "react";
import "./ContactModal.css";
import { RiCustomerService2Fill } from "react-icons/ri";
import Call from "../assets/call.svg";
import Whatsapp from "../assets/whatsapp.svg";
import Email from "../assets/mail.svg";
import Arrow from "../assets/arrow.svg";
import Close from "../assets/close.svg";
import axios from "axios";
const ContactModal = ({otherDetailsUser, constant, user}) => {
	console.log(otherDetailsUser);
  const [isOpen, setIsOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const modalRef = useRef(null);

  const toggleModal = () => {
    if (isOpen) {
      setIsAnimating(true);
      setTimeout(() => {
        setIsAnimating(false);
        setIsOpen(false);
      }, 100);
    } else {
      setIsOpen(true);
    }
  };
  
  const sendRmMailForSupportByCommon= (source)=>{
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_myaccount.php?fun=supporttocallnow`,
      headers: { "Auth-Id": user.auth_id },
      data: {
        location:"TalkToUs "+source,
        call_support:"TalkToUs "+source,
      },
    })
      .then(function (response) {
       // checkUserLogin(response);
      })
      .catch(function (error) {
        
      })
      .finally(() => {
        
      }); 
  };

 useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        toggleModal(); 
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div>
      {!isOpen ? (
        <div
          className="sticky-button fc1 bg3 br24 cp p12 fs14 v-center jcsb ls1"
          onClick={toggleModal}
        >
          <RiCustomerService2Fill className="mr4 fs16 " />
          Talk to Us
        </div>
      ) : (
        <button
          className="sticky-button fc1 bg3 br24 cp fs14 v-center jcsb ls1"
          onClick={toggleModal}
        >
          <img src={Close} alt="close" />
        </button>
      )}

      {isOpen && (
        <div
          className={`bg1 modal-content ${
            isAnimating ? "slide-down" : ""
          }`}
          ref={modalRef} 
        >
          <div className="head-contact v-center pl20 pt20 bg3 pb20 fc1">
            <img
              src="https://hellocity.vercel.app/static/media/user.5faf09a7795d28bf5a2b.png"
              alt="User"
              className="user-image"
            />
            <div className="fs16 lh26 ls1">
              <p>Hello, 👋</p>
              <p className="mt4"> How can we help?</p>
            </div>
          </div>
          <div className="contact-options">
            <a
              href={"tel:+"+otherDetailsUser.student_rm_mobile}
              className="contact-option bg9 v-center jcsb"
            >
              <div className="info-contact v-center" onClick={() => sendRmMailForSupportByCommon("click on call")}>
                <img src={Call} alt="Call" />
                <div className="ml12 ls1">
                  <p className="contact-text">Give us a call</p>
                  <p className="contact-text-value">+91 {otherDetailsUser.student_rm_mobile}</p>
                </div>
              </div>
              <img src={Arrow} alt="arrow" />
            </a>
            <a
              href={"https://wa.me/"+otherDetailsUser.student_rm_mobile} target="_blank"
              className="contact-option bg10 v-center jcsb"  onClick={() => sendRmMailForSupportByCommon("click on whatsapp")}
            >
              <div className="info-contact v-center">
                <img src={Whatsapp} alt="WhatsApp" />
                <div className="ml12 ls1">
                  <p className="contact-text">WhatsApp</p>
                  <p className="contact-text-value">{otherDetailsUser.student_rm_mobile}</p>
                </div>
              </div>
              <img src={Arrow} alt="arrow" />
            </a>
            <a
              href={"mailto:"+otherDetailsUser.student_rm_email}
              className="contact-option bg11 v-center jcsb" onClick={() => sendRmMailForSupportByCommon("click on email")}
            >
              <div className="info-contact v-center">
                <img src={Email} alt="Email" />
                <div className="ml12 ls1">
                  <p className="contact-text">Drop us an email</p>
                  <p className="contact-text-value">{otherDetailsUser.student_rm_email}</p>
                </div>
              </div>
              <img src={Arrow} alt="arrow" />
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactModal;
